import React from 'react';
import { Wrapper } from 'AppReact';
import styled from 'styled-components';

export const ButtonsWrapper =  Wrapper(styled.div`margin: 20px; display: flex; justify-content: center; gap: 20px`);
